import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClientService } from '../../shared/services/http-client/http-client.service';
import { RequerimentoAdminItemDto, RequerimentoAdminQueryParams, StatusRequerimentoDto } from '../api/models';

const ADMIN_REQUERIMENTOS_PATH = '/v1/admin/requerimentos';

/** Chamadas HTTP à API de Requerimento de Benefício (backoffice). O mapeamento para a tela fica no service de domínio. */
@Injectable({
  providedIn: 'root',
})
export class RequerimentoOnlineSolicitacaoApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  /** Requerimentos enviados de todos os participantes, já filtrados; sem paginação (a tela ordena e pagina). */
  listarRequerimentos(params?: RequerimentoAdminQueryParams): Observable<RequerimentoAdminItemDto[]> {
    return this.httpClient.get<RequerimentoAdminItemDto[]>(ADMIN_REQUERIMENTOS_PATH, {
      params: this.toHttpParams(params),
      apiUrl: environment.apiRequerimentoBeneficioUrl,
    });
  }

  /** Códigos e rótulos de status da tela, na ordem da tela. */
  listarStatus(): Observable<StatusRequerimentoDto[]> {
    return this.httpClient.get<StatusRequerimentoDto[]>(`${ADMIN_REQUERIMENTOS_PATH}/status`, {
      apiUrl: environment.apiRequerimentoBeneficioUrl,
    });
  }

  private toHttpParams(params: RequerimentoAdminQueryParams = {}): HttpParams {
    return Object.entries(params).reduce(
      (httpParams, [chave, valor]) =>
        valor == null || valor === '' ? httpParams : httpParams.set(chave, String(valor)),
      new HttpParams(),
    );
  }
}
